import React from "react";
import { makeStyles, Box, Typography, Divider } from "@material-ui/core";
// import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  container: {
    borderRadius: 16,
    backgroundColor: "white",
    padding: 20,
  },
}));

export default function AdditionalInfoComponent({ /* lang, userLanguage, */ currentLanguage, getTranslation }) {
  const classes = useStyle();
  // const displayLanguage = currentLanguage || userLanguage; // No longer needed

  return (
    <Box p={2}>
      <Box className={classes.container}>
        <Box mb={1.5}>
          <Typography variant="body1" style={{ color: "#632FF9" }}>
            <b>{getTranslation("label.ADDITIONAL_INFORMATION")}</b>
          </Typography>
        </Box>
        <Divider />
        <Box mt={1.5}>
          <Box>
            <Typography variant="body1">
              <b>
                {getTranslation("label.EXAMPLE_LABEL")}:{" "}
                {getTranslation("label.EXPIRED_DATE")}
              </b>
            </Typography>
            <Typography variant="body2">
              {getTranslation("label.EXAMPLE_LABEL")}: 12 May 2025
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">
              <b>
                {getTranslation("label.EXAMPLE_LABEL")}:{" "}
                {getTranslation("label.MANUFACTURED_DATE")}
              </b>
            </Typography>
            <Typography variant="body2">
              {getTranslation("label.EXAMPLE_LABEL")}: 12 May 2023
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">
              <b>
                {getTranslation("label.EXAMPLE_LABEL")}:{" "}
                {getTranslation("label.INGREDIENT")}
              </b>
            </Typography>
            <Typography variant="body2">
              {getTranslation("label.EXAMPLE_LABEL")}: Lorem ipsum dolor sit
              amet, cum sapientem
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
